import { createContext, useState, useContext, useEffect } from "react";
import { usePagSeguroContext } from "./PagSeguroContext";
import { emailValidation } from "../utils";
import { hashGenerate } from "../utils";

export const InvoiceContext = createContext();

export const InvoiceProvider = ({ children }) => {
  const {
    installmentsArr,
    setInstallmentsArr,
    creditCardBrand,
    pagSeguroDirectPaymentInstance,
  } = usePagSeguroContext();
  const [invoice, setInvoice] = useState({
    invoice: {
      general_info: {
        hash: "",
        id_invoice: "",
        id_cliente: "",
        id_revenda: "",
        tipo_pagamento: "",
        valor_total: 0.0,
        valor_desconto: 0.0,
        valor_liquido: 0.0,
        id_desconto: null,
        tipo_desconto: null,
        perc_desconto: null,
        desconto_desc: 0.0,
        pg_card: {
          token: "",
          sender_hash: "",
          installments: 0,
          installments_value: 0.0,
          owner: {
            name: "",
            cpf: "",
            birth_date: "",
            phone: "",
          },
        },
      },
      customer: {
        id: "",
        cnp: "",
        doc_type: "",
        xnome: "",
        xfant: "",
        xlgr: "",
        nro: "",
        xcpl: "",
        xbairro: "",
        xmun: "",
        cmun: "",
        uf: "",
        cep: "",
        fone: "",
        fone_alt: "",
        aceita_whats: "S",
        email: "",
        confirm_email: "",
        receita_situacao: "",
        licenses: [],
        produtor_rural: false,
      },
      cart: [],
    },
  });

  useEffect(() => {
    const hash = hashGenerate(invoice);
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          hash: hash,
        },
      },
    }));
  }, [
    invoice.invoice.customer.id,
    invoice.invoice.general_info.tipo_pagamento,
    invoice.invoice.general_info.valor_total,
    invoice.invoice.customer.email,
    invoice.invoice.customer.fone,
    invoice.invoice.cart,
  ]);

  const setCNP = (cnp) => {
    cnp = cnp.replace(/\D/g, "");
    let docType = cnp.length === 11 ? "CPF" : "CNPJ";

    setInvoice({
      ...invoice,
      invoice: {
        ...invoice.invoice,
        customer: {
          ...invoice.invoice.customer,
          cnp: cnp,
          doc_type: docType,
        },
      },
    });
  };

  const setCustomer = (customer) => {
    customer.fone =
      customer.fone === null || typeof customer.fone === "undefined"
        ? ""
        : customer.fone;
    customer.fone_alt =
      customer.fone_alt === null || typeof customer.fone_alt === "undefined"
        ? ""
        : customer.fone_alt;
    customer.email =
      customer.email === null || typeof customer.email === "undefined"
        ? ""
        : customer.email;
    customer.xfant =
      customer.xfant === null || typeof customer.xfant === "undefined"
        ? ""
        : customer.xfant;
    customer.xlgr =
      customer.xlgr === null || typeof customer.xlgr === "undefined"
        ? ""
        : customer.xlgr;
    customer.nro =
      customer.nro === null || typeof customer.nro === "undefined"
        ? ""
        : customer.nro;
    customer.xcpl =
      customer.xcpl === null || typeof customer.xcpl === "undefined"
        ? ""
        : customer.xcpl;
    customer.xbairro =
      customer.xbairro === null || typeof customer.xbairro === "undefined"
        ? ""
        : customer.xbairro;
    customer.xmun =
      customer.xmun === null || typeof customer.xmun === "undefined"
        ? ""
        : customer.xmun;
    customer.cmun =
      customer.cmun === null || typeof customer.cmun === "undefined"
        ? ""
        : customer.cmun;
    customer.uf =
      customer.uf === null || typeof customer.uf === "undefined"
        ? ""
        : customer.uf;
    customer.cep =
      customer.cep === null || typeof customer.cep === "undefined"
        ? ""
        : customer.cep;
    customer.aceita_whats = "S";
    customer.receita_situacao =
      customer.receita_situacao === null ||
      typeof customer.receita_situacao === "undefined"
        ? ""
        : customer.receita_situacao;

    customer.fone = customer.fone.replace(/\D/g, "");
    customer.fone_alt = customer.fone_alt.replace(/\D/g, "");

    if (customer.fone.length < 10) customer.fone = "";
    if (customer.fone_alt.length < 10) customer.fone_alt = "";

    if (customer.fone.length > 11 && customer.fone.charAt(2) === "9") {
      customer.fone = customer.fone.slice(0, 11);
    } else if (customer.fone.length > 10 && customer.fone.charAt(2) !== "9") {
      customer.fone = customer.fone.slice(0, 10);
    }

    if (customer.fone_alt.length > 11 && customer.fone_alt.charAt(2) === "9") {
      customer.fone_alt = customer.fone_alt.slice(0, 11);
    } else if (
      customer.fone_alt.length > 10 &&
      customer.fone_alt.charAt(2) !== "9"
    ) {
      customer.fone_alt = customer.fone_alt.slice(0, 10);
    }

    customer.cep = customer.cep.replace(/\D/g, "");

    if (!emailValidation(customer.email)) customer.email = "";

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          id_cliente: customer.id,
        },
        customer: {
          ...prevInvoice.invoice.customer,
          ...customer,
        },
      },
    }));
  };

  const setFieldCustomer = (field, value) => {
    setInvoice({
      ...invoice,
      invoice: {
        ...invoice.invoice,
        customer: {
          ...invoice.invoice.customer,
          [field]: value,
        },
      },
    });
  };

  const setInvoiceCart = (cart) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        cart: cart,
      },
    }));
  };

  const setInvoicePaymentMethod = (paymentMethod) => {
    setInvoice({
      ...invoice,
      invoice: {
        ...invoice.invoice,
        general_info: {
          ...invoice.invoice.general_info,
          tipo_pagamento: paymentMethod,
        },
      },
    });
  };

  const setDiscountType = (type) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          tipo_desconto: type,
        },
      },
    }));
  };

  const setDiscountPerc = (perc) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          perc_desconto: perc,
        },
      },
    }));
  };
  

  const updateLiquidPrice = (total) => {
    let liquidPrice;
    let discount = invoice.invoice.general_info.valor_desconto;
    if (invoice.invoice.general_info.tipo_desconto === '$' || invoice.invoice.general_info.tipo_desconto === null) {
      console.log("tipo desconto: $");
      liquidPrice = total - invoice.invoice.general_info.valor_desconto;
    }

    if (invoice.invoice.general_info.tipo_desconto === '%' && invoice.invoice.general_info.perc_desconto !== null) {
      console.log("tipo desconto: %");
      discount = total * (invoice.invoice.general_info.perc_desconto / 100);
      liquidPrice = total - discount;
    }

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          valor_liquido: parseFloat(liquidPrice).toFixed(2),
          valor_desconto: parseFloat(discount).toFixed(2),
        },
      },
    }));
  };

  const setInvoiceTotal = (total) => {
    if (installmentsArr.length > 0) {
      setInstallmentsArr([]);
      setPGCardInstallmentsQuantity(0);
      setPGCardInstallmentsValue(0.0);

      pagSeguroDirectPaymentInstance.getInstallments({
        amount: total,
        maxInstallmentNoInterest: 3,
        brand: creditCardBrand,
        success: function (response) {
          console.log(response);
          setInstallmentsArr(response.installments[creditCardBrand]);
        },
        error: function (response) {
          console.error("Error ao atualizar parcelas: ", response);
        },
      });
    }

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          valor_total: parseFloat(total).toFixed(2),
        },
      },
    }));

    updateLiquidPrice(total);
  };

  const setInvoiceDiscount = (discount) => {
    setInvoice((prevInvoice) => {
      const updatedInvoice = {
        ...prevInvoice,
        invoice: {
          ...prevInvoice.invoice,
          general_info: {
            ...prevInvoice.invoice.general_info,
            valor_desconto: parseFloat(discount).toFixed(2),
          },
        },
      };
  
      const liquidPrice = updatedInvoice.invoice.general_info.valor_total - parseFloat(discount);
  
      return {
        ...updatedInvoice,
        invoice: {
          ...updatedInvoice.invoice,
          general_info: {
            ...updatedInvoice.invoice.general_info,
            valor_liquido: parseFloat(liquidPrice).toFixed(2),
          },
        },
      };
    });
  };

  const addItemInCart = (item) => {
    // se for um serviço de rede = id entre 20 e 29
    if (item.id >= 20 && item.id <= 21) {
      // verifica se já existe um serviço de rede no carrinho
      const itemExists = invoice.invoice.cart.find(
        (cartItem) => cartItem.id >= 20 && cartItem.id <= 29,
      );

      if (itemExists) {
        // remove qualquer serviço de rede que já esteja no carrinho
        const cartWithoutItem = invoice.invoice.cart.filter(
          (cartItem) => cartItem.id < 20 || cartItem.id > 21,
        );

        // salva novo carrinho com o serviço de rede atualizado
        setInvoice((prevInvoice) => ({
          ...prevInvoice,
          invoice: {
            ...prevInvoice.invoice,
            cart: [...cartWithoutItem, item],
          },
        }));

        return;
      }
    }

    if (item.id >= 30 && item.id <= 39) {
      // verifica se já existe um pacote de placas
      const itemExists = invoice.invoice.cart.find(
        (cartItem) => cartItem.id >= 30 && cartItem.id <= 39,
      );

      if (itemExists) {
        // remove qualquer serviço de rede que já esteja no carrinho
        const cartWithoutItem = invoice.invoice.cart.filter(
          (cartItem) => cartItem.id < 30 || cartItem.id > 39,
        );

        // salva novo carrinho com o serviço de rede atualizado
        setInvoice((prevInvoice) => ({
          ...prevInvoice,
          invoice: {
            ...prevInvoice.invoice,
            cart: [...cartWithoutItem, item],
          },
        }));

        return;
      }
    }

    // verifica se o produto tem termo de uso e adiciona um campo para aceitar o termo
    if (item.tem_termo === "S") {
      if (item.termo_aceito === undefined) {
        item.termo_aceito = '0';
      }
    }

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        cart: [...prevInvoice.invoice.cart, item],
      },
    }));
  };

  const removeItemOfCart = (index) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        cart: prevInvoice.invoice.cart.filter((_, i) => i !== index),
      },
    }));
  };

  const updateItemTermById = (id, term) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        cart: prevInvoice.invoice.cart.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              termo_aceito: term ? '1' : '0',
            };
          }

          return item;
        }),
      },
    }));
  };

  const setInvoiceID = (id) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          id_invoice: parseInt(id),
        },
      },
    }));
  };

  const getInvoiceValue = () => {
    return invoice.invoice.general_info.valor_liquido;
  };

  const setPGCardToken = (token) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          pg_card: {
            ...prevInvoice.invoice.general_info.pg_card,
            token: token,
          },
        },
      },
    }));
  };

  const setPGCardSenderHash = (senderHash) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          pg_card: {
            ...prevInvoice.invoice.general_info.pg_card,
            sender_hash: senderHash,
          },
        },
      },
    }));
  };

  const setPGCardInstallmentsQuantity = (quantity) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          pg_card: {
            ...prevInvoice.invoice.general_info.pg_card,
            installments: quantity,
          },
        },
      },
    }));
  };

  const setPGCardInstallmentsValue = (value) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          pg_card: {
            ...prevInvoice.invoice.general_info.pg_card,
            installments_value: value,
          },
        },
      },
    }));
  };

  const setPGCardOwnerName = (name) => {
    name = name.toUpperCase();

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          pg_card: {
            ...prevInvoice.invoice.general_info.pg_card,
            owner: {
              ...prevInvoice.invoice.general_info.pg_card.owner,
              name: name,
            },
          },
        },
      },
    }));
  };

  const setPGCardOwnerCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "");

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          pg_card: {
            ...prevInvoice.invoice.general_info.pg_card,
            owner: {
              ...prevInvoice.invoice.general_info.pg_card.owner,
              cpf: cpf,
            },
          },
        },
      },
    }));
  };

  const setPGCardOwnerBirthDate = (birthDate) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          pg_card: {
            ...prevInvoice.invoice.general_info.pg_card,
            owner: {
              ...prevInvoice.invoice.general_info.pg_card.owner,
              birth_date: birthDate,
            },
          },
        },
      },
    }));
  };

  const setPGCardOwnerPhone = (phone) => {
    phone = phone.replace(/\D/g, "");

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          pg_card: {
            ...prevInvoice.invoice.general_info.pg_card,
            owner: {
              ...prevInvoice.invoice.general_info.pg_card.owner,
              phone: phone,
            },
          },
        },
      },
    }));
  };

  const getCreditCardOwnerData = () => {
    return {
      name: invoice.invoice.general_info.pg_card.owner.name,
      cpf: invoice.invoice.general_info.pg_card.owner.cpf,
      birth_date: invoice.invoice.general_info.pg_card.owner.birth_date,
      phone: invoice.invoice.general_info.pg_card.owner.phone,
    };
  };

  const cleanCustomer = () => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          // ...prevInvoice.invoice.customer,
          id: "",
          cnp: "",
          xnome: "",
          xfant: "",
          xlgr: "",
          nro: "",
          xcpl: "",
          xbairro: "",
          xmun: "",
          uf: "",
          cep: "",
          fone: "",
          fone_alt: "",
          email: "",
          confirm_email: "",
          receita_situacao: "",
          licenses: [],
        },
      },
    }));
  };

  const setCustomerPhone = (phone) => {
    phone = phone.replace(/\D/g, "");

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          fone: phone,
        },
      },
    }));
  };

  const setCustomerPhoneAlt = (phone) => {
    phone = phone.replace(/\D/g, "");

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          fone_alt: phone,
        },
      },
    }));
  };

  const setAcceptWhats = (accept) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          aceita_whats: accept,
        },
      },
    }));
  };

  const setCustomerCEP = (cep) => {
    cep = cep.replace(/\D/g, "");

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          cep: cep,
        },
      },
    }));
  };

  const setCustomerCity = (city) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          xmun: city,
        },
      },
    }));
  };

  const setCustomerState = (state) => {
    state = state.toUpperCase();

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          uf: state,
        },
      },
    }));
  };

  const setCustomerNeighborhood = (neighborhood) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          xbairro: neighborhood,
        },
      },
    }));
  };

  const setCustomerStreet = (street) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          xlgr: street,
        },
      },
    }));
  };

  const setCustomerIBGE = (ibge) => {
    ibge = ibge.replace(/\D/g, "");

    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          cmun: ibge,
        },
      },
    }));
  };

  const setCustomerID = (id) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          id_cliente: id,
        },
        customer: {
          ...prevInvoice.invoice.customer,
          id: id,
        },
      },
    }));
  };

  const setIDDiscount = (id) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        general_info: {
          ...prevInvoice.invoice.general_info,
          id_desconto: id,
        },
      },
    }));
  };

  const setRuralProducer = (isRuralProducer) => {
    setInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoice: {
        ...prevInvoice.invoice,
        customer: {
          ...prevInvoice.invoice.customer,
          produtor_rural: isRuralProducer,
        },
      },
    }));
  };

  return (
    <InvoiceContext.Provider
      value={{
        invoice,
        paymentMethod: invoice.invoice.general_info.tipo_pagamento,
        cnp: invoice.invoice.customer.cnp,
        setCNP,
        cnpType: invoice.invoice.customer.doc_type,
        setCustomer,
        setFieldCustomer,
        setInvoiceCart,
        setInvoiceTotal,
        setInvoiceDiscount,
        setDiscountType,
        setDiscountPerc,
        invoiceDiscount: parseFloat(invoice.invoice.general_info.valor_desconto),
        invoiceTotal: parseFloat(invoice.invoice.general_info.valor_total),
        invoiceLiquidTotal: parseFloat(invoice.invoice.general_info.valor_liquido),
        cart: invoice.invoice.cart,
        setInvoicePaymentMethod,
        removeItemOfCart,
        updateItemTermById,
        addItemInCart,
        setInvoiceID,
        invoiceID: invoice.invoice.general_info.id_invoice,
        getInvoiceValue,
        setPGCardToken,
        setPGCardSenderHash,
        setPGCardInstallmentsQuantity,
        setPGCardInstallmentsValue,
        setPGCardOwnerName,
        setPGCardOwnerCPF,
        setPGCardOwnerBirthDate,
        setPGCardOwnerPhone,
        getCreditCardOwnerData,
        getInstallmentsQuantity:
          invoice.invoice.general_info.pg_card.installments,
        customer: invoice.invoice.customer,
        cleanCustomer,
        setCustomerPhone,
        setCustomerPhoneAlt,
        setAcceptWhats,
        setCustomerCEP,
        setCustomerCity,
        setCustomerState,
        setCustomerNeighborhood,
        setCustomerStreet,
        setCustomerID,
        setCustomerIBGE,
        setIDDiscount,
        setRuralProducer,
        isRuralProducer: invoice.invoice.customer.produtor_rural,
      }}
    >
      {children}
    </InvoiceContext.Provider>
  );
};

export const useInvoiceContext = () => {
  return useContext(InvoiceContext);
}
